import { Grid, Col } from '.';
import * as React from 'react';
import * as styles from './gridShow.scss';
import * as colStyles from 'components/grid/col.scss';

type Props = {
    zIndex?: number;
    hide?: boolean;
}

const GridShow: React.SFC<Props> = props => {

    return (
        <div className={styles.gridWp} style={{zIndex: props.zIndex,display: props.hide? 'none': 'block'}}>
            <Grid>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>1</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>2</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>3</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>4</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>5</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>6</span>
                </Col>

                <Col className={colStyles.col1}>
                    <span className={styles.span}>7</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>8</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>9</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>10</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>11</span>
                </Col>
                <Col className={colStyles.col1}>
                    <span className={styles.span}>12</span>
                </Col>
            </Grid>
        </div>
    )
}

GridShow.defaultProps = {
    zIndex: -1
};

export default GridShow;
